import React, { useEffect, useState } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { signInWithPopup } from "firebase/auth";
import { useDispatch } from "react-redux";
import { loginWithGoogle } from '../../reducers/commonReducer';
import { useNavigate } from "react-router-dom";


const LoginPop = ({ onClose, title ,id}) => {
  
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const firebaseConfig = {
    apiKey: "AIzaSyCI9ApS1WDUYoPXNdNlYq_OZ7PVnCxYvmE",
    authDomain: "taxnwealth-5eca0.firebaseapp.com",
    projectId: "taxnwealth-5eca0",
    storageBucket: "taxnwealth-5eca0.firebasestorage.app",
    messagingSenderId: "719213400308",
    appId: "1:719213400308:web:9c5e8d301d42fce848cea1"
  };
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const provider = new GoogleAuthProvider();

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    if (onClose) onClose();
  };

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider); // 👈 make sure this is popup
      const user = result.user;
      const idToken = await result.user.getIdToken();
      if(idToken){
        const loginapiResp = await dispatch(loginWithGoogle({
          idToken
        }))
        if(loginapiResp?.payload?.status || localStorage.getItem("x-auth-token")){
          if (id) {
            
            navigate(`/plans-details?id=${id}`);
          }
          else{
            navigate(`/user-dashboard`);
          }
        }
      }
      console.log("Token:",user, idToken);
    } catch (error) {
      console.error("Login error", error);
    }
  };

  return (
    <>
      <Button className='login-btn' onClick={handleShow}>
        {title}
      </Button>

      <Modal show={show} onHide={handleClose} centered size="lg" className="login-modal">
        <Modal.Body className="p-4">
          <Row>
            <Col md={6} className="d-flex flex-column align-items-center justify-content-center text-center">
              <img
                src="https://d17x24txz4ixmz.cloudfront.net/images/logo4x.webp"
                alt="taxNwealth logo"
                className="img-fluid mb-3"
                style={{ maxWidth: "180px" }}
              />
              <Button onClick={handleLogin} className="mt-3 w-75" >
                Login with Google
              </Button>
              <p className="terms mt-3 text-muted small">
                By continuing, you agree to taxNwealth's <a href="#">Terms of Use</a> and <a href="#">Privacy Policy</a>.
              </p>
            </Col>

            <Col md={6} className="right-section mbl-hide">
              <img
                src="https://d17x24txz4ixmz.cloudfront.net/images/contact-us.webp"
                alt="Secure login illustration"
                className="img-fluid"
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="">
        <button className="close-btn " onClick={handleClose}>×</button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LoginPop;


// import React, { useState, useEffect, useRef } from 'react';
// import { useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { Login } from '../../reducers/commonReducer';
// import { messages } from '../../helpers/apiStructure';

// const LoginPop = ({ onClose }) => {
//   const [phone, setPhone] = useState('');
//   const [otp, setOtp] = useState('');
//   const [timer, setTimer] = useState(0);
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpVerified, setOtpVerified] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const otpInputRef = useRef(null);

//   // Timer logic
//   useEffect(() => {
//     let interval = null;
//     if (timer > 0) {
//       interval = setInterval(() => {
//         setTimer((prev) => prev - 1);
//       }, 1000);
//     }
//     return () => clearInterval(interval);
//   }, [timer]);

//   const formatTime = (time) => {
//     const minutes = String(Math.floor(time / 60)).padStart(2, '0');
//     const seconds = String(time % 60).padStart(2, '0');
//     return `${minutes}:${seconds}`;
//   };

//   // Send OTP handler
//   const handleSendOtp = () => {
//     if (!phone || phone.length < 10) {
//       messages('Please enter a valid phone number.', 'error');
//       return;
//     }

//     setOtp('');
//     setOtpSent(true);
//     setOtpVerified(false);
//     setTimer(300);

//     // Focus OTP field after a short delay
//     setTimeout(() => {
//       otpInputRef.current?.focus();
//     }, 200);
//   };

//   // Submit OTP
//   const handleSaveOtp = async () => {
//     try {
//       const res = await dispatch(Login({ phone, otp }));
//       if (res?.payload?.status === 1) {
      
//         setOtpVerified(true);
//         onClose();
//         navigate('/');
//       } else {
//         messages('Login failed. Please check your OTP.', 'error');
//       }
//     } catch (error) {
//       messages('An error occurred during login.', 'error');
//       console.error(error);
//     }
//   };

//   return (
//     <div className="login-popup-overlay">
//       <div className="login-popup">
//         <div className="left-section">
//           <img
//             src="https://d17x24txz4ixmz.cloudfront.net/images/logo4x.webp"
//             alt="taxNwealth"
//             className="logo"
//           />

//           <input
//             type="text"
//             className="google-btn"
//             placeholder="Enter Phone No"
//             value={phone}
//             onChange={(e) => setPhone(e.target.value)}
//           />

//           {otpSent && (
//             <>
//               <input
//                 ref={otpInputRef}
//                 type="text"
//                 className="google-btn mt-2"
//                 placeholder="Enter OTP"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//               />

//               <div className="pt-2">
//                 <button
//                   className="btn btn-success w-auto"
//                   onClick={handleSaveOtp}
//                   disabled={otp.length !== 6}
//                 >
//                   Submit
//                 </button>
//               </div>
//             </>
//           )}

//           <div className="pt-2">
//             <button
//               className="btn btn-primary w-auto"
//               onClick={handleSendOtp}
//               disabled={timer > 0}
//             >
//               {timer > 0 ? `Resend in ${formatTime(timer)}` : 'Send OTP'}
//               <i className="bi bi-arrow-right ms-2"></i>
//             </button>
//           </div>

//           <p className="terms mt-3">
//             By continuing, you agree to taxNwealth's <a href="#">Terms of Use</a> and{' '}
//             <a href="#">Privacy Policy</a>.
//           </p>
//         </div>

//         <div className="right-section mbl-hide">
//           <img
//             src="https://www.taxnwealth.com/images/secure-login.png"
//             alt="Login Illustration"
//           />
//         </div>

//         <button className="close-btn dasktop-hide" onClick={onClose}>
//           ×
//         </button>
//       </div>
//     </div>
//   );
// };

// export default LoginPop;






